<ng-container *transloco="let t; read: 'configuration-item-editor-component'">
  @if (isLoading) {
    <div class="configuration-item-editor__loading">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @if (configuration().removed) {
    <div class="configuration-item-editor__deleted">
      {{ t('deleted') }}
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="editor" />
  }

  <ng-template #editor>
    <as-split direction="horizontal">
      <as-split-area [size]="leftSplitSize" [minSize]="25">
        <div
          class="configuration-item-editor__editor-template-wrapper configuration-item-editor__editor-left-template"
        >
          @if (!testMode) {
            <div #listLayout class="configuration-item-editor__item-list-layout">
              <div class="configuration-item-editor__item-list-title-bar">
                <div class="configuration-item-editor__title">
                  {{ t('title-list', { itemTypeTitle: translatedItemTypeTitle }) }}
                </div>

                <div class="configuration-item-editor__title-actions">
                  @if (canEditItem) {
                    <xi-default-button
                      text="{{ t('delete-all') }}"
                      [disabled]="isSaving || !configItems.length"
                      (onClick)="deleteAllItems()"
                    ></xi-default-button>

                    <div
                      class="configuration-item-editor__add-button"
                      [class.configuration-item-editor__add-button--highlight]="
                        this.addButtonPopover()?.isOpen()
                      "
                      #addButtonPopover="ngbPopover"
                      [ngbPopover]="addPopoverTemplate()"
                      popoverClass="configuration-item-editor__add-button-popover"
                      triggers="manual"
                      placement="right"
                      [autoClose]="false"
                      [container]="'body'"
                      matTooltip="{{
                        t('create-new-item', {
                          itemTypeTitle: translatedItemTypeTitle,
                        })
                      }}"
                    >
                      <xi-icon-button
                        color="CX"
                        icon="add_circle"
                        [disabled]="isSaving || !isValid"
                        (onClick)="addItem()"
                      >
                      </xi-icon-button>
                    </div>
                  }
                </div>
              </div>

              <div #searchWrapper class="configuration-item-editor__search-wrapper">
                @if (canSearchBy()) {
                  <div class="configuration-item-editor__search-type">
                    <span>{{ t('search') }}</span>

                    <div
                      class="configuration-item-editor__radio-group"
                      (change)="onSearchTypeChanged()"
                    >
                      <xi-radio
                        name="searchRadio"
                        value="all"
                        label="{{ t('both') }}"
                        [(ngModel)]="searchType"
                      ></xi-radio>

                      <xi-radio
                        name="searchRadio"
                        value="name"
                        label="{{ t('name') }}"
                        [(ngModel)]="searchType"
                      ></xi-radio>

                      <xi-radio
                        name="searchRadio"
                        value="query"
                        label="{{ t('query') }}"
                        [(ngModel)]="searchType"
                      ></xi-radio>
                    </div>
                  </div>
                }
                @if (!isLoadingPage) {
                  <xi-search-box
                    class="configuration-item-editor__filter"
                    [placeholder]="searchPlaceholder()"
                    [disabled]="isSaving"
                    [value]="searchValue"
                    (onChangeOverride)="onSearchChanged($event.detail.searchText)"
                    (onFocus)="onSearchFocused($event)"
                  ></xi-search-box>
                }
                <div class="configuration-item-editor__search-icons-wrapper">
                  @if (searchValue) {
                    <div @searchControlTrigger>
                      <xi-icon-button
                        icon="single_arrow_left"
                        color="CX"
                        [disabled]="filteredConfigItems.length < 2 || isSaving"
                        (onClick)="searchPrevious()"
                      ></xi-icon-button>
                    </div>

                    <div @searchControlTrigger>
                      <xi-icon-button
                        icon="single_arrow_right"
                        color="CX"
                        [disabled]="filteredConfigItems.length < 2 || isSaving"
                        (onClick)="searchNext()"
                      ></xi-icon-button>
                    </div>
                  }
                  @if (!hasOptionsPopout()) {
                    <div
                      #itemSortPopover="ngbPopover"
                      [ngbPopover]="tItemSort"
                      popoverClass="info-popover configuration-item-editor__sort-popover"
                      container="body"
                      placement="left-top"
                      [autoClose]="'outside'"
                      class="configuration-item-editor__add-button"
                    >
                      <div [matTooltip]="itemSort.label">
                        <xi-icon-button icon="sort_order_desc" color="CX"></xi-icon-button>
                      </div>
                    </div>
                  }
                </div>

                @if (hasOptionsPopout()) {
                  <xi-icon-button
                    #optionsPopoutButton
                    icon="settings"
                    color="CX"
                    matTooltip="{{ t('query-topic-display-options') }}"
                    (onClick)="onOpenOptionsPopout()"
                  >
                  </xi-icon-button>
                }
              </div>

              @if (configItems?.length === 0 && editorMode === 'none') {
                <div class="configuration-item-editor__empty-selection">
                  {{ t('none-found', { itemTypeTitle: translatedItemTypeTitle }) }}
                </div>
              } @else {
                <ng-container *ngTemplateOutlet="itemList" />
              }

              <ng-template #itemList>
                <cdk-virtual-scroll-viewport
                  #itemListScroll
                  class="configuration-item-editor__item-list-scroll-viewport"
                  [itemSize]="scrollViewportItemSize"
                  (scrolledIndexChange)="onScrollDown()"
                >
                  <mat-action-list role="list">
                    @if (editorMode === 'create') {
                      <button
                        mat-list-item
                        role="listitem"
                        [disabled]="isSaving"
                        (keyup.space)="$event.preventDefault()"
                        class="configuration-item-editor__row--new"
                      >
                        <ng-template
                          *ngTemplateOutlet="listRowLayout; context: { $implicit: selectedItem() }"
                        >
                        </ng-template>
                      </button>
                    }

                    <button
                      *cdkVirtualFor="let item of filteredConfigItems"
                      mat-list-item
                      role="listitem"
                      [disabled]="isSaving"
                      (click)="checkAndSelectItem(item)"
                      (keyup.space)="$event.preventDefault()"
                      [class.configuration-item-editor__row--selected]="selectedItem() === item"
                      tabindex="-1"
                    >
                      <ng-template *ngTemplateOutlet="listRowLayout; context: { $implicit: item }">
                      </ng-template>

                      <div
                        class="configuration-item-editor__delete-row"
                        [matTooltip]="getDeleteItemTooltip(item.id)"
                      >
                        @if (itemsEditable()) {
                          <xi-icon-button
                            icon="trash"
                            color="CX"
                            [disabled]="taxonomyItemUsage()?.includes(item.id) || !canEditItem"
                            (onClick)="deleteItem()"
                          >
                          </xi-icon-button>
                        }
                      </div>

                      @if (!itemsEditable()) {
                        <xi-icon icon="password_filled"></xi-icon>
                      }
                    </button>

                    <ng-template #listRowLayout let-item>
                      <div
                        class="configuration-item-editor__item-hidden"
                        [class.configuration-item-editor__item-hidden--double]="
                          itemSort.value === 'modification_date'
                        "
                      >
                        @if (item.hidden) {
                          <mat-icon>{{ t('hide-source') }}</mat-icon>
                        }
                      </div>

                      <div class="configuration-item-editor__item-name">
                        <ng-container
                          *appMiddleEllipsize="item[namePropName()] || item[queryPropName()]"
                        ></ng-container>

                        @if (itemSort.value === 'modification_date') {
                          <div class="configuration-item-editor__item-updated">
                            {{ item.modification_date | lexDate }}
                          </div>
                        }
                      </div>

                      <div class="configuration-item-editor__row-extra">
                        <ng-template
                          *ngTemplateOutlet="rowExtraTemplate(); context: { $implicit: item }"
                        >
                        </ng-template>
                      </div>
                    </ng-template>
                  </mat-action-list>
                </cdk-virtual-scroll-viewport>
              </ng-template>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="editorLayout" />
          }
        </div>
      </as-split-area>

      <as-split-area [size]="rightSplitSize" [minSize]="20">
        <div
          class="configuration-item-editor__editor-template-wrapper configuration-item-editor__editor-right-template"
        >
          @if (testMode) {
            <ng-container *ngTemplateOutlet="testLayout" />
          } @else {
            <ng-container *ngTemplateOutlet="editorLayout" />
          }
        </div>
      </as-split-area>
    </as-split>
  </ng-template>

  <!-- TESTER TEMPLATE-->
  <ng-template #testLayout>
    <div class="configuration-item-editor__query-tester-layout">
      <!-- TEST DOCUMENTS TITLE BAR -->
      <div class="configuration-item-editor__query-tester-title-bar">
        <div class="configuration-item-editor__title">
          {{ t('tester', { itemTypeTitle: translatedItemTypeTitle }) }}
        </div>

        <div
          matTooltip="{{ diabledTestButtonToolTip() }}"
          [matTooltipDisabled]="(isTestButtonDisabled$ | async) === false"
          matTooltipClass="tooltip-newline"
          class="configuration-item-editor__test-run-documents-button"
        >
          <xi-default-button
            text="{{ t('run-test') }}"
            buttonSize="small"
            iconLeft="play_control_filled"
            [disabled]="isEvaluationInProgress || (isTestButtonDisabled$ | async)"
            (onClick)="evaluateItem()"
            [tabindex]="-1"
          ></xi-default-button>
        </div>
      </div>

      @if (configTesterState.availableTabs.length > 1) {
        <div class="kxi-horizontal-tab-bar--equal">
          <xi-horizontal-tab-bar
            [data]="configTesterTabs"
            [activeTabId]="configTesterState.selectedTab"
            [hasTransparentBackground]="true"
            [stretchWidth]="true"
            color="CX"
            (onTabChange)="onConfigurationTesterTabChange($event.detail.tab.id)"
          >
          </xi-horizontal-tab-bar>
        </div>
      }

      <div class="configuration-item-editor__query-tester-tabs">
        <div
          [ngClass]="
            configTesterState.selectedTab === 'use-dataset'
              ? 'configuration-item-editor__show'
              : 'configuration-item-editor__hide'
          "
          [class.fullscreen]="isTesterFullscreen"
        >
          <div class="configuration-item-editor__query-tester-toolbar">
            @if (!configTesterState.dataset) {
              <xi-default-button
                iconLeft="plus"
                fill="outline"
                buttonSize="small"
                [text]="t('choose-testing-data')"
                [tabindex]="-1"
                [matMenuTriggerFor]="testingDataActionsTrigger"
                [disabled]="configTesterState.loading || isEvaluationInProgress"
              ></xi-default-button>
            } @else {
              <xi-default-button
                fill="fill"
                color="orca"
                buttonSize="small"
                [iconLeft]="configTesterState.dataset?.icon"
                [text]="configTesterState.dataset.descriptor.description | truncate: 24 ?? ''"
                [tooltip]="{ text: configTesterState.dataset.descriptor.description }"
                [tabindex]="-1"
                [matMenuTriggerFor]="testingDataActionsTrigger"
                [disabled]="configTesterState.loading || isEvaluationInProgress"
              ></xi-default-button>
            }

            <mat-menu class="menu-with-xi-icons" #testingDataActionsTrigger>
              <div [matTooltipPosition]="'left'">
                <button
                  mat-menu-item
                  (click)="showSelectCollectionDialog()"
                  [disabled]="configTesterState.loading || isEvaluationInProgress"
                >
                  <xi-icon icon="collections"></xi-icon>
                  <div>{{ t('select-collection') }}</div>
                </button>
              </div>
              <div [matTooltipPosition]="'left'">
                <button
                  mat-menu-item
                  (click)="showCSVFileUploadDialog()"
                  [disabled]="configTesterState.loading || isEvaluationInProgress"
                >
                  <xi-icon icon="upload"></xi-icon>
                  <div>{{ t('upload-file') }}</div>
                </button>
              </div>
            </mat-menu>

            @if (availableStatuses.length > 0) {
              <div class="configuration-item-editor__status-filter-wrapper">
                <div class="configuration-item-editor__status-filter-label">
                  {{ t('statuses') }}
                </div>
                <xi-default-button
                  fill="outline"
                  buttonSize="small"
                  [text]="getStatusFilterButtonText(t)"
                  [tabindex]="-1"
                  [ngbPopover]="statusFilterPopoverTemplate"
                  popoverClass="configuration-item-editor__status-filter-popover"
                  placement="bottom-right"
                  [autoClose]="'outside'"
                  triggers="manual"
                  #statusFilterPopover="ngbPopover"
                  (onClick)="statusFilterPopover.toggle()"
                  [disabled]="configTesterState.loading || isEvaluationInProgress"
                ></xi-default-button>
              </div>

              <ng-template #statusFilterPopoverTemplate>
                <div class="configuration-item-editor__status-filter-list">
                  @for (status of availableStatuses; track status) {
                    <div class="status-filter-row" (click)="toggleStatus(status)">
                      <xi-checkbox
                        color="CX"
                        [checked]="isStatusSelected(status)"
                        style="pointer-events: none"
                      ></xi-checkbox>
                      <div class="status-info">
                        <xi-icon
                          [icon]="RESULT_STATUS_INFO[status]?.icon"
                          [color]="RESULT_STATUS_INFO[status]?.color"
                        ></xi-icon>
                        {{ t('status-value.' + status) }}
                      </div>
                    </div>
                  }
                </div>
              </ng-template>
            }
          </div>

          @if (configTesterState.collectionSelectVisible) {
            <app-lex-xi-modal
              [isVisible]="configTesterState.collectionSelectVisible"
              [canBackdropClose]="false"
              maxWidth="600px"
              (close)="
                onSelectCollectionDialogClosed({ confirmed: false, selectedCollection: null })
              "
            >
              <ng-template appXIModalContent>
                @if (configTesterState.collectionSelectVisible) {
                  <app-configuration-collection-selector
                    [isShowing]="configTesterState.collectionSelectVisible"
                    (modalClosed)="onSelectCollectionDialogClosed($event)"
                  ></app-configuration-collection-selector>
                }
              </ng-template>
            </app-lex-xi-modal>
          }

          @if (configTesterState.csvUploadVisible) {
            <app-import-dialog
              [isShowing]="configTesterState.csvUploadVisible"
              [title]="t('upload-file')"
              [allowedExtensions]="['csv', 'xlsx', 'xls']"
              [uploadNotes]="configTesterState.csvUploadNotes"
              [requiresConfirmation]="true"
              [notificationType]="'snackbar'"
              [itemValidator]="configTesterState.csvValidator"
              (modalClosed)="onCsvFileUploadDialogClosed($event)"
              (filesConfirmed)="onCsvFilesConfirmed($event)"
            >
            </app-import-dialog>
          }

          <div class="configuration-item-editor__query-tester-use-dataset-content">
            @if (configTesterState.loading) {
              <div class="configuration-item-editor__query-tester-use-dataset--loading">
                <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
              </div>
            }
            <app-configuration-tester-document-list
              [class.configuration-item-editor__content-hidden]="
                configTesterState.loading ||
                !configTesterState.evaluation?.completed ||
                configTesterState.evaluation?.expired
              "
              [selectedItem]="selectedItem()"
              [selectedItemChanged]="hasChanges"
              [isDisabled]="isEvaluationInProgress"
              [isEvaluationInProgress]="isEvaluationInProgress"
              [highlightTextFunction]="getHighlightTextString"
              [highlightValueFunction]="getEvaluationItemHighlightValue"
              [statusFilter]="selectedStatuses"
              [isFullscreen]="isTesterFullscreen"
              (fullscreenToggled)="toggleTesterFullscreen()"
              (availableStatuses)="onAvailableStatusesChanged($event)"
              (resultsCleared)="onCTDocumentListResultsCleared($event)"
              (resultsArrived)="onCTDocumentListResultsArrived($event)"
            >
            </app-configuration-tester-document-list>
            <div
              class="configuration-item-editor__query-tester-use-dataset-instructions"
              [class.configuration-item-editor__content-hidden]="
                configTesterState.loading ||
                (configTesterState.evaluation?.completed && !configTesterState.evaluation?.expired)
              "
            >
              @if (isEvaluationInProgress) {
                <p class="configuration-item-editor__query-tester-use-dataset-instructions-text">
                  {{ t('test-data-is-processing') }}
                </p>
              } @else if (configTesterState.dataset) {
                <xi-svg svg="document_okay"></xi-svg>
                <p class="configuration-item-editor__query-tester-use-dataset-instructions-text">
                  {{ t('test-data-ready-to-be-tested') }}
                </p>
              } @else {
                <xi-svg svg="plus"></xi-svg>
                <p class="configuration-item-editor__query-tester-use-dataset-instructions-text">
                  {{ t('use-dataset-instructions') }}
                </p>
              }
            </div>
          </div>
        </div>

        <div
          [ngClass]="
            configTesterState.selectedTab === 'create-documents'
              ? 'configuration-item-editor__show'
              : 'configuration-item-editor__hide'
          "
        >
          <!-- TOOLBAR -->
          <div class="configuration-item-editor__query-tester-toolbar">
            @if (configurationItemIsQueryTopic() && hasTestDocumentGenerationPermission) {
              <xi-default-button
                text="{{ t('create-test-doc') }}"
                iconLeft="plus"
                fill="outline"
                buttonSize="small"
                [disabled]="testDocuments.length >= maxTestDocumentCount"
                [tabindex]="-1"
                [matMenuTriggerFor]="createTestDocumentMenuTrigger"
              ></xi-default-button>

              <mat-menu #createTestDocumentMenuTrigger class="menu-with-xi-icons">
                <button
                  mat-menu-item
                  [disabled]="testDocuments.length >= maxTestDocumentCount"
                  (click)="addEmptyDocument()"
                >
                  <xi-icon-button icon="plus" color="CX"></xi-icon-button>
                  <span>{{ t('add-empty') }}</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="testDocuments.length >= maxTestDocumentCount"
                  (click)="onGenerateTestDocuments()"
                >
                  <xi-icon-button icon="plus" color="CX"></xi-icon-button>
                  <span>{{ t('generate-with-spot-e') }}</span>
                </button>
              </mat-menu>
            } @else {
              <ng-container *ngTemplateOutlet="singleCreateButton" />
            }

            <ng-template #singleCreateButton>
              <xi-default-button
                text="{{ t('create-test-doc') }}"
                iconLeft="plus"
                fill="outline"
                buttonSize="small"
                [disabled]="testDocuments.length >= maxTestDocumentCount"
                [tabindex]="-1"
                (onClick)="addEmptyDocument()"
              ></xi-default-button>
            </ng-template>

            <xi-default-button
              text="{{ t('delete-all') }}"
              iconLeft="trash"
              fill="outline"
              buttonSize="small"
              [disabled]="isEvaluationInProgress || (isTestButtonDisabled$ | async)"
              (onClick)="onDeleteAllDocuments()"
              [tabindex]="-1"
            ></xi-default-button>
          </div>

          <!-- TEST DOCUMENT LIST -->
          <div class="test-document-list-wrapper">
            @for (document of testDocuments; track document; let i = $index) {
              <div class="card test-document-card">
                <div class="configuration-item-editor__test-document-header">
                  <div class="configuration-item-editor__test-document-actions-left">
                    <!--
                    @fixme
                    @see ConfigurationQueryTopicsComponent.setDocumentHitIcon (src\app\modules\configuration\components\configuration-query-topics\configuration-query-topics.component.ts)
                    @see ConfigurationDetailsTabBase.setDocumentHitIcon (src\app\modules\configuration\components\configuration-details-tab-base.ts)
                  -->
                    <div
                      [id]="'evaluation-checkmark-' + document.documentId"
                      class="configuration-item-editor__evaluation-checkmark"
                    >
                      <div class="configuration-item-editor__evaluation-checkmark-hit-sign">
                        <mat-icon svgIcon="check"></mat-icon>
                        <span>{{ t('hit') }}</span>
                      </div>

                      <div class="configuration-item-editor__evaluation-checkmark-miss-sign">
                        <mat-icon svgIcon="horizontal_rule"></mat-icon>
                        {{ t('didnt-hit') }}
                      </div>
                    </div>

                    <xi-icon-button
                      icon="parentheses"
                      color="CX"
                      [tooltip]="{ text: t('stem-tooltip') }"
                      [disabled]="!document.hasBeenTested || document.rephraseInProgress"
                      (onClick)="onShowStemmedVersionModal(i)"
                    ></xi-icon-button>
                  </div>

                  <div class="configuration-item-editor__test-document-actions-right">
                    @if (document.rephraseInProgress) {
                      <div
                        class="configuration-item-editor__test-document-rephrase-in-progress-indicator"
                      >
                        <xi-animation
                          [height]="75"
                          [width]="75"
                          [loop]="true"
                          animation="cx_loader"
                        ></xi-animation>
                      </div>
                    }
                    @if (configurationItemIsQueryTopic() && hasRephrasePermission) {
                      <xi-icon-button
                        icon="refresh"
                        color="CX"
                        [disabled]="
                          !document.canRephrase ||
                          document.rephraseInProgress ||
                          isEvaluationInProgress
                        "
                        [tooltip]="{ text: t('rephrase-document') }"
                        (onClick)="onRephraseDocument(document.documentId)"
                      ></xi-icon-button>
                    }
                    <xi-icon-button
                      icon="trash"
                      color="CX"
                      (onClick)="removeDocument(i)"
                      [disabled]="document.rephraseInProgress || isEvaluationInProgress"
                    ></xi-icon-button>
                  </div>
                </div>

                <div
                  appContentEditable
                  [(ngModel)]="document.value"
                  [disabled]="isEvaluationInProgress || document.rephraseInProgress"
                  [id]="'test-document-' + document.documentId"
                  (input)="clearSpans($event)"
                  class="configuration-item-editor__test-document-textbox"
                  [class.configuration-item-editor__test-document-textbox--disabled]="
                    isEvaluationInProgress || document.rephraseInProgress
                  "
                ></div>
              </div>
            }
          </div>

          <div class="configuration-item-editor__query-tester-footer">
            <span>{{
              t('x-out-of-y', { length: testDocuments.length, maxTestDocumentCount })
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- EDITOR TEMPLATE -->
  <ng-template #editorLayout>
    <div class="configuration-item-editor__editor-layout" [class.fullscreen]="isFullscreen()">
      @if (!selectedItem()) {
        <div class="configuration-item-editor__empty-selection">
          {{ t('none-selected', { itemTypeTitle: translatedItemTypeTitle }) }}
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="itemSelection"></ng-container>
      }

      <ng-template #itemSelection>
        <div class="configuration-item-editor__editor-title-bar">
          <div class="configuration-item-editor__editor-title">
            @if (testMode) {
              <xi-icon-button
                icon="single_arrow_left"
                (onClick)="onEditModeClicked()"
              ></xi-icon-button>
            }
            <div class="configuration-item-editor__title">
              @if (queryPropName() !== namePropName()) {
                @if (canEditItem) {
                  <ng-container *ngTemplateOutlet="nameInlineEditor" />
                } @else {
                  <ng-container *ngTemplateOutlet="noEdit" />
                }
              } @else {
                <ng-container *ngTemplateOutlet="itemTypeTitleTemplate" />
              }
              <ng-template #noEdit>{{ selectedItem()[namePropName()] }}</ng-template>

              <ng-template #itemTypeTitleTemplate>
                {{ t('type-editor', { itemTypeTitle: translatedItemTypeTitle }) }}
              </ng-template>

              @if (configuration().layer) {
                <div class="configuration-item-editor__subtitle">
                  {{ t('source', { name: selectedItemLayer?.name }) }}
                </div>
              }
            </div>
          </div>

          <div class="configuration-item-editor__editor-title-bar-actions">
            @if (syntaxHelpLink()) {
              <a [href]="syntaxHelpLink()" target="_blank">
                <xi-icon-button icon="question_mark" [tabindex]="-1" color="CX"></xi-icon-button>
              </a>
            }
            @if (queryEditable) {
              <xi-default-button
                text="{{ t(fullscreenTooltip) }}"
                fill="text"
                iconLeft="{{ fullscreenIcon }}"
                (onClick)="toggleFullscreen()"
              ></xi-default-button>
            }
            @if (configuration.layer) {
              <div [matTooltip]="editDefinitionTooltip">
                <xi-default-button
                  text="{{ t('edit-definition') }}"
                  buttonSize="small"
                  [disabled]="!selectedItemLayer?.isConfiguration"
                  (onClick)="onEditDefintionClicked()"
                  [tabindex]="-1"
                >
                </xi-default-button>
              </div>
            }
            @if (queryEditable()) {
              @if (!testMode && canEditItem) {
                <div
                  [matTooltip]="testModeButtonTooltip"
                  class="configuration-item-editor__test-button-wrapper"
                >
                  <xi-default-button
                    text="{{ t('test') }}"
                    buttonSize="small"
                    [disabled]="!testingEnabled()"
                    (onClick)="onTestModeClicked()"
                    [tabindex]="-1"
                  ></xi-default-button>
                </div>
              }
            }
          </div>
        </div>

        @if (editorTemplate()) {
          <div class="configuration-item-editor__editor-toolbar">
            <ng-template
              *ngTemplateOutlet="editorTemplate(); context: { $implicit: selectedItem() }"
            ></ng-template>
          </div>
        }

        <div class="configuration-item-editor__editor-content-wrapper">
          @if (queryEditable() && selectedItem()) {
            <code-editor
              @editorTrigger
              [(ngModel)]="query"
              [lineWrapping]="true"
              [placeholder]="queryPlaceholder()"
              [readonly]="!itemsEditable() || authService.isReadOnly"
              [setup]="'basic'"
              [extensions]="lexQueryExtensions"
            ></code-editor>
          }
        </div>

        @if (canEditItem) {
          <div class="configuration-item-editor__editor-footer">
            <xi-default-button
              buttonSize="small"
              text="{{ t('cancel') }}"
              fill="outline"
              [disabled]="isSaving || !hasChanges"
              (onClick)="cancelEdit()"
            ></xi-default-button>

            <xi-default-button
              buttonSize="small"
              [text]="
                t('save', { itemTypeTitle: convertItemTypeToTranslatedVersion(itemTypeTitle()) })
              "
              [disabled]="!hasChanges || !isValid || isSaving"
              (onClick)="saveEdit()"
            ></xi-default-button>
          </div>
        }
      </ng-template>
    </div>
  </ng-template>

  <ng-template #nameInlineEditor>
    <app-inline-edit
      appEditOnEnter
      [control]="itemName"
      class="configuration-item-editor__item-name-editor"
      [class.configuration-item-editor__item-name-editor--dense]="
        itemSort.value === 'modification_date'
      "
      [(mode)]="inlineEditorMode"
    >
      <ng-template appViewMode>
        <div class="configuration-item-editor__item-name-editor--view">
          @if (!itemName.value) {
            <span class="configuration-item-editor__item-name-editor--placeholder">
              {{ t('enter-name') }}
            </span>
          }

          <ng-container *appMiddleEllipsize="itemName.value"></ng-container>

          <xi-icon-button
            icon="edit"
            color="CX"
            (onClick)="inlineEditorMode = 'edit'"
          ></xi-icon-button>

          @if (itemSort.value === 'modification_date') {
            <div class="configuration-item-editor__item-updated">
              {{ selectedItem().modification_date | lexDate }}
            </div>
          }
        </div>
      </ng-template>

      <ng-template appEditMode>
        <mat-form-field
          class="configuration-item-editor__item-name-editor--edit"
          [style.width.%]="100"
          [subscriptSizing]="'dynamic'"
        >
          <input matInput appAutoFocus [autoFocusTimeout]="100" [formControl]="itemName" />

          @if (itemName.hasError('minLength')) {
            <mat-error>
              {{ t('name-error-length-min', { minLength: itemName.errors.minLength.minLength }) }}
            </mat-error>
          }
          @if (itemName.hasError('maxLength')) {
            <mat-error>
              {{ t('name-error-length-max', { maxLength: itemName.errors.maxLength.maxLength }) }}
            </mat-error>
          }
          @if (itemName.hasError('nameAlreadyExists')) {
            <mat-error>{{ t('duplicate-name') }}</mat-error>
          }
        </mat-form-field>
      </ng-template>
    </app-inline-edit>
  </ng-template>

  <ng-template #tItemSort>
    <mat-list class="configuration-item-editor__sort-menu">
      @for (option of itemSortValues; track option) {
        <mat-list-item (click)="onSortItemClicked(option)">
          <mat-icon matListIcon>
            {{ option === itemSort ? 'check' : '' }}
          </mat-icon>

          <span matLine> {{ option.label }} </span>
        </mat-list-item>
      }
    </mat-list>
  </ng-template>

  @if (showStemmedDocumentModal) {
    <app-lex-xi-modal [isVisible]="showStemmedDocumentModal" (close)="onCloseStemmedVersionModal()">
      <ng-template appXIModalContent>
        @if (showStemmedDocumentModal) {
          <app-lex-xi-simple-modal
            [data]="stemmedDocumentData"
            (modalClosed)="onCloseStemmedVersionModal()"
          ></app-lex-xi-simple-modal>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (isOptionsPopoutVisible) {
    <app-lex-xi-popout
      [isVisible]="isOptionsPopoutVisible"
      [element]="optionsPopoutButton?.nativeElement"
      (close)="onCloseOptionsPopout()"
    >
      <ng-template appXIPopoutContent>
        @if (isOptionsPopoutVisible) {
          <app-configuration-item-editor-options-popout
            [(options)]="configurationItemListOptions"
          ></app-configuration-item-editor-options-popout>
        }
      </ng-template>
    </app-lex-xi-popout>
  }
</ng-container>
